export const AUTH_COOKIE = '@AUTH_COOKIE'
export const AUTH_TOKEN = '@auth_token'
export const NATIVE_BASE_URL = '@native_base_url'
export const VIDEO_AUTO_PLAY = '@video_auto_play'
